import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Briefcase, RotateCcw } from 'lucide-react';
import { ADMIN_PAGES_KEYS, NS } from '../../../../i18n/constants/keys';

export interface JobOpeningsEmptyStateProps {
  isFiltersApplied: boolean;
  onClearFilters: () => void;
}

export const JobOpeningsEmptyState = ({
  isFiltersApplied,
  onClearFilters,
}: JobOpeningsEmptyStateProps) => {
  const { t } = useTranslation(NS.adminPages);

  return (
    <Box
      sx={{
        py: 8,
        px: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          p: 2.5,
          borderRadius: '50%',
          bgcolor: 'grey.100',
          color: 'text.secondary',
          mb: 2,
        }}
      >
        <Briefcase size={36} />
      </Box>

      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary', mb: 0.5 }}>
        No job openings found
      </Typography>

      <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 360, mb: 3 }}>
        {isFiltersApplied
          ? 'Try adjusting your search criteria or removing active filters to see more results.'
          : 'There are currently no job openings available in this view.'}
      </Typography>

      {isFiltersApplied && (
        <Button
          variant="outlined"
          size="small"
          onClick={onClearFilters}
          startIcon={<RotateCcw size={14} />}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '0.8125rem',
            fontWeight: 600,
          }}
        >
          {t(ADMIN_PAGES_KEYS.jobOpenings.list.drawer.reset)}
        </Button>
      )}
    </Box>
  );
};
